import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const ServicesSolutionsSection = () => {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState(0);

  const solutions = [
    {
      title: {
        fr: 'Solutions sur mesure',
        ar: 'حلول مخصصة',
        en: 'Custom Solutions'
      },
      description: {
        fr: 'Nous concevons des solutions d\'instrumentation parfaitement adaptées aux besoins spécifiques de votre industrie et de vos processus, garantissant une performance optimale et une intégration transparente.',
        ar: 'نصمم حلول قياس مصممة تمامًا وفقًا للاحتياجات المحددة لصناعتك وعملياتك، مما يضمن الأداء الأمثل والتكامل السلس.',
        en: 'We design instrumentation solutions perfectly tailored to the specific needs of your industry and processes, ensuring optimal performance and seamless integration.'
      },
      image: '/images/solution-1.jpg',
      features: [
        {
          fr: 'Analyse approfondie des besoins spécifiques',
          ar: 'تحليل متعمق للاحتياجات المحددة',
          en: 'In-depth analysis of specific needs'
        },
        {
          fr: 'Conception personnalisée de systèmes d\'instrumentation',
          ar: 'تصميم مخصص لأنظمة القياس',
          en: 'Custom design of instrumentation systems'
        },
        {
          fr: 'Intégration avec les systèmes existants',
          ar: 'التكامل مع الأنظمة الحالية',
          en: 'Integration with existing systems'
        },
        {
          fr: 'Documentation technique complète',
          ar: 'وثائق تقنية كاملة',
          en: 'Complete technical documentation'
        },
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: {
        fr: 'Maintenance prédictive',
        ar: 'الصيانة التنبؤية',
        en: 'Predictive Maintenance'
      },
      description: {
        fr: 'Nos services de maintenance prédictive utilisent des technologies avancées pour identifier les problèmes potentiels avant qu\'ils ne surviennent, minimisant ainsi les temps d\'arrêt et prolongeant la durée de vie de vos équipements.',
        ar: 'تستخدم خدمات الصيانة التنبؤية لدينا تقنيات متقدمة لتحديد المشكلات المحتملة قبل حدوثها، مما يقلل من وقت التوقف عن العمل ويطيل عمر معداتك.',
        en: 'Our predictive maintenance services use advanced technologies to identify potential problems before they occur, thus minimizing downtime and extending the life of your equipment.'
      },
      image: '/images/solution-2.jpg',
      features: [
        {
          fr: 'Surveillance continue des performances',
          ar: 'المراقبة المستمرة للأداء',
          en: 'Continuous performance monitoring'
        },
        {
          fr: 'Analyse de données avancée',
          ar: 'تحليل البيانات المتقدم',
          en: 'Advanced data analysis'
        },
        {
          fr: 'Détection précoce des anomalies',
          ar: 'الكشف المبكر عن الشذوذ',
          en: 'Early anomaly detection'
        },
        {
          fr: 'Planification optimisée de la maintenance',
          ar: 'تخطيط الصيانة الأمثل',
          en: 'Optimized maintenance planning'
        },
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      )
    },
    {
      title: {
        fr: 'Formation et certification',
        ar: 'التدريب والشهادات',
        en: 'Training and Certification'
      },
      description: {
        fr: 'Nous proposons des programmes de formation complets pour votre personnel, garantissant qu\'ils disposent des connaissances et des compétences nécessaires pour exploiter et maintenir efficacement vos systèmes d\'instrumentation.',
        ar: 'نقدم برامج تدريبية شاملة لموظفيك، مما يضمن أن لديهم المعرفة والمهارات اللازمة لتشغيل أنظمة القياس والحفاظ عليها بكفاءة.',
        en: 'We offer comprehensive training programs for your staff, ensuring they have the knowledge and skills needed to effectively operate and maintain your instrumentation systems.'
      },
      image: '/images/solution-3.jpg',
      features: [
        {
          fr: 'Formation pratique sur site',
          ar: 'التدريب العملي في الموقع',
          en: 'Hands-on on-site training'
        },
        {
          fr: 'Documentation de formation détaillée',
          ar: 'وثائق تدريب مفصلة',
          en: 'Detailed training documentation'
        },
        {
          fr: 'Certification des opérateurs',
          ar: 'شهادات المشغلين',
          en: 'Operator certification'
        },
        {
          fr: 'Support post-formation',
          ar: 'دعم ما بعد التدريب',
          en: 'Post-training support'
        },
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path d="M12 14l9-5-9-5-9 5 9 5z" />
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
        </svg>
      )
    },
    {
      title: {
        fr: 'Support technique 24/7',
        ar: 'الدعم الفني على مدار الساعة',
        en: '24/7 Technical Support'
      },
      description: {
        fr: 'Notre équipe de support technique est disponible 24 heures sur 24, 7 jours sur 7, pour répondre rapidement à tout problème et garantir le bon fonctionnement continu de vos systèmes critiques.',
        ar: 'فريق الدعم الفني لدينا متاح على مدار 24 ساعة طوال أيام الأسبوع، للاستجابة بسرعة لأي مشكلة وضمان التشغيل المستمر لأنظمتك الحيوية.',
        en: 'Our technical support team is available 24 hours a day, 7 days a week, to respond quickly to any issue and ensure the continuous operation of your critical systems.'
      },
      image: '/images/solution-4.jpg',
      features: [
        {
          fr: 'Assistance téléphonique et en ligne 24/7',
          ar: 'الدعم الهاتفي وعبر الإنترنت على مدار الساعة',
          en: '24/7 phone and online assistance'
        },
        {
          fr: 'Temps de réponse garantis',
          ar: 'وقت استجابة مضمون',
          en: 'Guaranteed response times'
        },
        {
          fr: 'Support à distance avancé',
          ar: 'دعم متقدم عن بعد',
          en: 'Advanced remote support'
        },
        {
          fr: 'Équipe de techniciens sur le terrain',
          ar: 'فريق من الفنيين الميدانيين',
          en: 'Field technician team'
        },
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      )
    }
  ];

  return (
    <section className="section bg-white" style={{ 
      padding: '5rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '-10%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>

      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '-5%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        {/* Section header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'NOS SOLUTIONS' : 
             language === 'ar' ? 'حلولنا' : 
             'OUR SOLUTIONS'}
          </span>

          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Solutions d\'instrumentation avancées' : 
             language === 'ar' ? 'حلول قياس متقدمة' : 
             'Advanced Instrumentation Solutions'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: '#4a5568',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Des solutions complètes pour optimiser vos opérations, réduire les temps d\'arrêt et améliorer l\'efficacité globale de vos installations Pétrole, Gaz et Industrie.' 
              : language === 'ar'
              ? 'حلول شاملة لتحسين عملياتك، وتقليل وقت التوقف عن العمل، وتحسين الكفاءة الشاملة لمنشآتك البتروكيماوية.'
              : 'Comprehensive solutions to optimize your operations, reduce downtime, and improve overall efficiency of your petrochemical facilities.'}
          </p>
        </div>
        
        {/* Solutions tabs */}
        <div style={{ 
          backgroundColor: 'rgba(247, 250, 252, 0.8)',
          borderRadius: '16px',
          padding: '3rem',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
          position: 'relative'
        }}>
          {/* Tab navigation */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            borderBottom: '1px solid #e2e8f0',
            marginBottom: '2rem',
            gap: '1rem',
            paddingBottom: '1rem'
          }}>
            {solutions.map((solution, index) => (
              <button 
                key={index}
                onClick={() => setActiveTab(index)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1.25rem',
                  borderRadius: '100px',
                  border: 'none',
                  backgroundColor: activeTab === index ? 'var(--assco-orange)' : 'transparent',
                  color: activeTab === index ? 'white' : '#4a5568',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem'
                }}
                onMouseOver={(e) => {
                  if (activeTab !== index) {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 107, 0, 0.1)';
                  }
                }}
                onMouseOut={(e) => {
                  if (activeTab !== index) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <div style={{
                  width: '24px',
                  height: '24px',
                  color: activeTab === index ? 'white' : 'var(--assco-orange)'
                }}>
                  {solution.icon}
                </div>
                {language === 'fr' ? solution.title.fr : 
                 language === 'ar' ? solution.title.ar : 
                 solution.title.en}
              </button>
            ))}
          </div>
          
          {/* Tab content */}
          {solutions.map((solution, index) => (
            <div 
              key={index} 
              style={{
                display: activeTab === index ? 'block' : 'none',
                animation: activeTab === index ? 'fadeIn 0.5s ease' : 'none'
              }}
            >
              <div className="grid" style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(12, 1fr)',
                gap: '3rem',
                alignItems: 'center'
              }}>
                <div className="col-span-5 md-col-span-12">
                  <div style={{ 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    height: '400px',
                    position: 'relative',
                    backgroundColor: `hsl(${(index * 40) % 360}, 70%, 97%)`
                  }}>
                    {/* Solution image placeholder - in a real application, use actual images */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: [
                        `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 600 400'%3E%3Crect width='600' height='400' fill='%23f8fafc'/%3E%3Cpath d='M300,50 L150,350 L450,350 Z' fill='%23${index === 0 ? 'FF6B00' : index === 1 ? '3182ce' : index === 2 ? '805ad5' : '38a169'}' fill-opacity='0.1'/%3E%3Cpath d='M300,100 L200,300 L400,300 Z' fill='%23${index === 0 ? 'FF6B00' : index === 1 ? '3182ce' : index === 2 ? '805ad5' : '38a169'}' fill-opacity='0.2'/%3E%3Ccircle cx='300' cy='150' r='80' fill='%23${index === 0 ? 'FF6B00' : index === 1 ? '3182ce' : index === 2 ? '805ad5' : '38a169'}' fill-opacity='0.3'/%3E%3C/svg%3E")`
                      ][index % 1],
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      opacity: 1
                    }}></div>
                    
                    {/* Solution icon overlay */}
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      width: '70px',
                      height: '70px',
                      borderRadius: '16px',
                      backgroundColor: `hsl(${(index * 40) % 360}, 70%, 40%)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
                      transform: 'rotate(-5deg)'
                    }}>
                      <div style={{ width: '36px', height: '36px' }}>
                        {solution.icon}
                      </div>
                    </div>
                    
                    {/* Badge */}
                    <div style={{
                      position: 'absolute',
                      bottom: '30px',
                      left: '30px',
                      backgroundColor: 'white',
                      borderRadius: '100px',
                      padding: '0.75rem 1.5rem',
                      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem'
                    }}>
                      <div style={{
                        width: '24px', 
                        height: '24px',
                        color: `hsl(${(index * 40) % 360}, 70%, 40%)`
                      }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                      </div>
                      <span style={{ fontWeight: '600', fontSize: '0.95rem' }}>
                        {language === 'fr' ? 'Solution certifiée' : 
                         language === 'ar' ? 'حل معتمد' : 
                         'Certified solution'}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="col-span-7 md-col-span-12">
                  <h3 style={{ 
                    fontSize: '2rem',
                    fontWeight: '700',
                    marginBottom: '1.5rem',
                    color: '#1a202c',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}>
                    <span style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: `hsl(${(index * 40) % 360}, 70%, 95%)`,
                      color: `hsl(${(index * 40) % 360}, 70%, 40%)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <div style={{ width: '22px', height: '22px' }}>
                        {solution.icon}
                      </div>
                    </span>
                    {language === 'fr' ? solution.title.fr : 
                     language === 'ar' ? solution.title.ar : 
                     solution.title.en}
                  </h3>
                  
                  <p style={{ 
                    fontSize: '1.125rem',
                    lineHeight: '1.8',
                    marginBottom: '2.5rem',
                    color: '#4a5568'
                  }}>
                    {language === 'fr' ? solution.description.fr : 
                     language === 'ar' ? solution.description.ar : 
                     solution.description.en}
                  </p>
                  
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#2d3748'
                  }}>
                    {language === 'fr' ? 'Caractéristiques principales:' : 
                     language === 'ar' ? 'الميزات الرئيسية:' : 
                     'Key features:'}
                  </h4>
                  
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '1rem',
                    marginBottom: '2.5rem'
                  }}>
                    {solution.features.map((feature, idx) => (
                      <div 
                        key={idx}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          padding: '1rem',
                          borderRadius: '10px',
                          backgroundColor: `hsl(${(index * 40) % 360}, 70%, 97%)`,
                          border: `1px solid hsl(${(index * 40) % 360}, 70%, 90%)`,
                          transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = `hsl(${(index * 40) % 360}, 70%, 95%)`;
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = `hsl(${(index * 40) % 360}, 70%, 97%)`;
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        <div style={{
                          width: '20px', 
                          height: '20px',
                          color: `hsl(${(index * 40) % 360}, 70%, 40%)`
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>
                          {language === 'fr' ? feature.fr : 
                           language === 'ar' ? feature.ar : 
                           feature.en}
                        </span>
                      </div>
                    ))}
                  </div>
                  
                  <button 
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      backgroundColor: `hsl(${(index * 40) % 360}, 70%, 40%)`,
                      color: 'white',
                      padding: '0.875rem 2rem',
                      borderRadius: '50px',
                      border: 'none',
                      fontWeight: '600',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: `0 10px 15px -3px hsla(${(index * 40) % 360}, 70%, 40%, 0.3)`
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = `hsl(${(index * 40) % 360}, 70%, 30%)`;
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = `0 20px 25px -5px hsla(${(index * 40) % 360}, 70%, 40%, 0.4)`;
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = `hsl(${(index * 40) % 360}, 70%, 40%)`;
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = `0 10px 15px -3px hsla(${(index * 40) % 360}, 70%, 40%, 0.3)`;
                    }}
                  >
                    {language === 'fr' ? 'Demander un devis' : 
                     language === 'ar' ? 'طلب عرض أسعار' : 
                     'Request a quote'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSolutionsSection;
